import React, { useState } from "react";
import classNames from "classnames/bind";
import styles from './FormRegister.module.css'
import { isValidateUserName, isValidatorEmail, isValidatorName } from "../../../../../utils";
import { TickIcon } from "../../../../../components/Icons/Icons";
import PropTypes from "prop-types";


const cx = classNames.bind(styles)

function InputText({ title, onChange, value, placeholder, type, disabled, name, error }) {
    const [isChange, setIsChange] = useState(false)
    const onChanges = (e) => {
        if (!isChange) {
            setIsChange(true)
        }

        onChange(e.target.value)
    }

    const checkRules = (data) => {
        if (isChange && name === "NAME") {
            if (!data || data.trim().length === 0) {
                return false
            }
            if (!isValidatorName(data)) {
                return false
            }
        }
        if (isChange && name === "USERNAME") {
            if (!data || data.trim().length === 0) {
                return false
            }
            if (!isValidateUserName(data)) {
                return false
            }
        }
        if (isChange && name === "EMAIL") {
            if (!data || data.trim().length === 0) {
                return false
            }
            if (!isValidatorEmail(data)) {
                return false
            }
        }
        return true
    }

    const getMess = (data) => {
        if (isChange && name === "NAME") {
            if (!data || data.trim().length === 0) {
                return "Tên người dùng không được bỏ trống"
            }
            if (!isValidatorName(data)) {
                return "Tên người dùng chỉ chứa các ký tự viết thường và viết hoa!"
            }
        }
        if (isChange && name === "USERNAME") {
            if (!data || data.trim().length === 0) {
                return 'Tên đăng nhập không được bỏ trống'
            }
            if (!isValidateUserName(data)) {
                return 'Tên người dùng dài từ 6 - 15 ký tự, chỉ chứa các ký tự viết thường và số.'
            }
        }
        if (isChange && name === "EMAIL") {
            if (!data || data.trim().length === 0) {
                return 'Địa chỉ Email không được bỏ trống'
            }
            if (!isValidatorEmail(data)) {
                return 'Địa chỉ Email không hợp lệ'
            }
        }
    }
    return (
        <div>
            <div className={cx("form-group")}>
                <label className={cx("title")}>{title}</label>
                <input
                    name={name}
                    value={value ? value : ""}
                    className={cx("input-textbox", !checkRules(value) ? "input-error" : "")}
                    onChange={onChanges}
                    type={type}
                    placeholder={placeholder}
                    disabled={disabled}
                />
                {checkRules(value) && isChange && <p className={cx('icon-succes')}><TickIcon /></p>}
            </div>
            {!checkRules(value) && isChange && <p className={cx("span-error")}>{getMess(value)}</p>}
            {error && error.trim().length > 0 && <p className={cx("span-error")}>{error}</p>}
        </div>
    );
};

InputText.propTypes = {
    title: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    placeholder: PropTypes.string,
    name: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    type: PropTypes.string,
    disabled: PropTypes.bool,
    error: PropTypes.string,
};

export default InputText;
